module.exports = __webpack_public_path__ + "img/streamer.8208488c.png";